import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { LeaveService } from '../../Model/Leave/leave.service';
import { SessionService } from '../../Util/Session/session.service';
import { ChartConfiguration, ChartOptions } from 'chart.js';
import { NgChartsModule } from 'ng2-charts';
import { CalendarService } from '../../Model/Calendar/calendar.service';
import { ChunkPipe } from '../../chunk/chunk.pipe';
import { FormsModule } from '@angular/forms';
import { NgbCalendar, NgbDate, NgbDateStruct, NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AttendanceService } from '../../Model/Attendance/attendance.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { UtilityService } from '../../Model/utility/utility.service';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';
import moment from 'moment';
import { PayslipService } from '../../Model/Payslip/payslip.service';
import { CommonService } from '../../Model/Common/common.service';
import { FeedService } from '../../Model/Feeds/feed.service';
import { log } from 'console';
import { HolidayService } from '../../Model/Holiday/holiday.service';
import { Router, RouterModule } from '@angular/router';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { CompensatoryOffService } from '../../Model/CompensatoryOff/compensatory-off.service';
import { LoginService } from '../../Model/Login/login.service';
import { MPINDialogComponent } from '../../Component/mpindialog/mpindialog.component';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, NgChartsModule, FormsModule, NgbDatepickerModule, RouterModule, LoaderComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {
  public User: any = null;
  isDisabled: boolean = false;
  //checkedIn: boolean = false;
  isShowAttendaceBtn: boolean = false;
  ToDayDate = null as any;
  CurrentTime = null as any;
  IntervalId: any;
  LateCheckInDuration: string = '0h 0m 0s';
  Duration: string = '0h 0m 0s';
  PaySlipData = [] as any;
  Holidays: any[] = [];
  calendarData: any[] = [];
  calendarDataSummary: any[] = [];
  LeaveTypes = [] as any;
  TodayBirthdayDetails = [] as any;
  FeedDetails = [] as any
  Comments = [] as any;
  commentSectionVisibleIndex: number | null = null;
  Comment = '';
  Colour1 = '';
  Colour2 = '';

  user = [] as any;
  greeting!: string;
  AttendanceDetail = {
    EmpMasterId: null,
    EmployeeName: null,
    EmpType: null,
    DesignationID: null,
    DesignationName: null,
    DutyID: null,
    DutyName: null,
    BranchID: null,
    BranchName: null,
    SiteID: null,
    SiteName: null,
    ShiftMasterID: null,
    ShiftTitle: null,
    AttendanceDate: null as any,
    InTime: null as any,
    OutTime: null as any,
    WorkingHour: null,
    AttendanceStatus: null,
    AttendanceStatusOut: null,
    AttendanceRemark: null,
    AttendanceRemarkOut: null,
    DailyAttendancePhoto: null,
    DailyAttendancePhotoOut: null,
    OpenMonth: null,
    OpenYear: null,
    BiometricAttendanceId: null,
    IsManual: null,
    AttendanceMatchPercentage: null,
    Latitude: null,
    Longitude: null,
    Altitude: null,
    NearByLocationName: null,
    BillableOT: null,
    NonBillableOT: null,
    RegularizationID_IN: null,
    RegularizationID_OUT: null,
    LeaveID: null,
    AttendanceDescription: null,
    ApprovalStatus: null,
    GeoTagged: null,
    MobileName: null,
    AccessCard: null,
    MobileId: null,
    Address: null,
    Remark: null,
    NearByLocationName1: null,
    IsOtherDuty: null,
    WebCheckInOut: null,
    MobileCheckInOut: null,
    GeoTagging: null,
    SiteQRCodeScanning: null,
    EmployeeQRCodeScanning: null,
    Selfie: null,
    SelfieType: null,
    EmployeeNotCheckIn: null,
    IsOtherDuty1: null,
    IsAttendanceAll: null,
    RestrictIP: null,
    IP: null,
    AttendanceType: null,
    Duration: null,
    HalfDayDuration: null,
    OTApplicable: null,
    OTApplicableIn: null,
    FirstCheckInLate: null,
    LastCheckOutEarly: null,
    Deviation: null,
    DeviationMoreThan: null,
    DeviationMoreThanPeriod: null,
    DeviationOccurMultiplyOf: null,
    DeviationOccurMultiplyOFPeriod: null,
    LeaveDeductDay: null,
    LeaveDeductType: null,
    ShiftMargin: null,
    HourBeforeShiftStart: null,
    HourAfterShiftStart: null,
    Insentive: null,
    AttendanceGreaterThan: null,
    AttendanceOccurMultiplyOf: null,
    AttendanceOccurMultiplyOfPeriod: null,
    IsCheckIn: false,
    IsAttendaceClose: false,
    SelectType: 'InsertUpdate',
  };

  CalendarDetailsData = {
    id: 0,
    Photo: null as any,
    EmployeeName: '',
    EmpCode: null,
    DesignationName: null,
    AttendanceDate: null as any,
    InTime: null,
    OutTime: null,
    ShiftTitle: null,
    Remark: null,
    DailyAttendancePhoto: null,
    DailyAttendancePhotoOut: null,
    InReason: null,
    OutReason: null,
    AttendanceDescription: null,
    TotalTime: ''
  }

  ShiftDetail = {
    ShiftFrom: '09:00:00 AM' as any,
    ShiftTo: '06:00:00 PM',
  };

  filter = {
    AttendanceDate: null as any
  }
  CompOffTable: any[] = [];
  CompOffCount: number = 0;
  constructor(
    private leave: LeaveService,
    private session: SessionService,
    private Calendar: CalendarService,
    private attendance: AttendanceService,
    private payslip: PayslipService,
    private toast: ToastService,
    private utility: UtilityService,
    protected common: CommonService,
    private post: FeedService,
    private holiday: HolidayService,
    protected dateFromat: CustomDateParserFormatter,
    private router: Router,
    private CompOff: CompensatoryOffService,
    private login: LoginService,
    private modalService: NgbModal,
  ) {
    this.ToDayDate = this.dateFromat.parse(moment(Date()).format("DD MMM YYYY"));
    this.common.CompanyParameter();
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    this.AttendanceDetail.EmpMasterId = this.user.UserId;
    this.SelectDate('RegistrationDate', null, null);
  }

  async ngOnInit() {
    if ((this.common.CompanyParameterValue.HTTPSDownloadLink == null || this.common.CompanyParameterValue.HTTPSDownloadLink == '') && this.user.first) {
      await new Promise(f => setTimeout(f, 2000));
      this.user.first = false;
      this.session.Start(this.user);
      window.location.reload();
    }
    this.setGreeting();
    this.GetPaySlip();
    this.getHolidaylistonID();
    this.LoadEmployeeLeaveCombo();
    this.GetFeedLoad();
    this.ESS_EmployeeCompOffConsumeLoad();
    if (this.user.IsPopFirstTimeMpin) {
      this.ESS_GetLoginDetails(true);
    }
  }

  CheckIn() {
    //if (this.AttendanceDetail.WebCheckInOut) {
    if (!this.AttendanceDetail.IsCheckIn) {
      this.AttendanceDetail.IsCheckIn = true;
      this.AttendanceDetail.InTime = this.CurrentTime;
      this.getIPAddress()
    }
    // } else {
    //   this.toast.show({ message: "Web attendance not allowed", type: toastTypeEnum.danger });
    // }
  }

  CheckOut() {
    if (this.AttendanceDetail.WebCheckInOut) {
      if (this.AttendanceDetail.IsCheckIn) {
        this.AttendanceDetail.IsCheckIn = false;
        clearInterval(this.IntervalId);
        this.IntervalId = null;
        this.AttendanceDetail.OutTime = this.CurrentTime;
        this.getIPAddress();
      }
    } else {
      this.toast.show({ message: "Web attendance not allowed", type: toastTypeEnum.danger });
    }
  }

  AttendanceInOutSave(): any {
    this.isDisabled = true;
    if (this.AttendanceDetail.IsCheckIn) {
      this.AttendanceDetail.InTime = this.AttendanceDetail.InTime._i.toString();
    } else if (!this.AttendanceDetail.IsCheckIn) {
      this.AttendanceDetail.OutTime = this.AttendanceDetail.OutTime._i.toString();
    }
    this.attendance.AttendanceInOutSave(this.AttendanceDetail).subscribe({
      next: (response) => {
        if (response.Error_Code == '01') {
          if (this.AttendanceDetail.IsCheckIn) {
            this.CheckInStart(this.CurrentTime, true);
          } else if (!this.AttendanceDetail.IsCheckIn) {
            this.AttendanceDetail.OutTime = this.CurrentTime;
          }
          this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
          this.AttendanceDetail.AttendanceDate = null;
          this.AttendanceDetail.InTime = null;
          this.AttendanceDetail.OutTime = null;
        } else {
          this.toast.show({ message: response.Error_Message, type: toastTypeEnum.danger });
        }
        this.SelectDate('RegistrationDate', null, null);
        this.isDisabled = false;
        return true;
      },
      complete: () => {
        //this.GetDailyAttendanceInOut();
        return true;
      },
      error: (error) => {
        this.isDisabled = false;
        return false;
      },
    });
  }

  CheckInStart(AttendanceDateTime: any, IsNewChekin: boolean) {
    this.ShiftDetail.ShiftFrom = moment(new Date(this.CurrentTime._i.split(' ')[0] + ' ' + this.ShiftDetail.ShiftFrom));
    this.AttendanceDetail.InTime = AttendanceDateTime;
    this.AttendanceDetail.OutTime = this.CurrentTime;
    if (this.AttendanceDetail.InTime > this.ShiftDetail.ShiftFrom) {
      this.LateCheckInDuration = this.calculateLate(this.AttendanceDetail.InTime, this.ShiftDetail.ShiftFrom);
    } else {
      this.LateCheckInDuration = '';
    }

    if (this.IntervalId != null) {
      clearInterval(this.IntervalId);
      this.IntervalId = null;
    }

    this.IntervalId = setInterval(() => {
      this.AttendanceDetail.OutTime = moment(this.AttendanceDetail.OutTime).add(moment.duration(1, 'second'));
      this.CalculateTimeDifference();
    }, 1000);

    this.isShowAttendaceBtn = true;
  }

  CalculateTimeDifference() {
    const startTime = this.AttendanceDetail.InTime;
    const endTime = this.AttendanceDetail.OutTime;
    const diff = endTime - startTime;
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);
    this.Duration = `${hours}h ${minutes}m ${seconds}s`;
  }

  calculateLate(actualTime: any, expectedTime: any): string {
    const diff = actualTime - expectedTime;
    if (diff > 0) {
      const hoursLate = Math.floor(diff / (1000 * 60 * 60)); // Convert milliseconds to hours
      const minutesLate = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)); // Convert remaining milliseconds to minutes
      const secondsLate = Math.floor((diff % (1000 * 60)) / 1000); // Convert remaining milliseconds to seconds

      return `${hoursLate} h ${minutesLate} m ${secondsLate} s`;
    } else {
      return 'On time';
    }
  }

  GetDailyAttendanceInOut() {
    this.isDisabled = true;
    this.attendance.GetDailyAttendanceInOut({ SelectType: 1, EmpMasterId: this.AttendanceDetail.EmpMasterId, MonthName: this.dateFromat.fullmonth[this.ToDayDate.month - 1], YearName: this.ToDayDate.year }).subscribe({
      next: (response) => {
        if (response.toString() != '') {
          this.AttendanceDetail = response[0];
          this.AttendanceDetail.SelectType = 'InsertUpdate';
          //this.AttendanceDetail.InTime = null;
          //this.AttendanceDetail.OutTime = null;
          if (moment(response[0].AttendanceDate).isSame(this.dateFromat.format(this.ToDayDate))) {
            if (response[0].InTime != null && response[0].OutTime == null) {
              this.AttendanceDetail.IsCheckIn = true;
              this.AttendanceDetail.InTime = moment(response[0].InTime);
              this.GetDateTime(false);
            } else if (response[0].InTime != null && response[0].OutTime != null) {
              this.AttendanceDetail.IsAttendaceClose = true;
              this.AttendanceDetail.IsCheckIn = false;
              this.AttendanceDetail.InTime = moment(response[0].InTime);
              this.AttendanceDetail.OutTime = moment(response[0].OutTime);
              this.CalculateTimeDifference();
              this.GetDateTime(false);
            } else {
              this.AttendanceDetail.InTime = null;
              this.AttendanceDetail.OutTime = null;
              this.isShowAttendaceBtn = true;
            }
          } else {
            if (response[0].InTime != null && response[0].OutTime == null) {
              this.AttendanceDetail.IsCheckIn = true;
              this.AttendanceDetail.InTime = moment(response[0].InTime);
              this.GetDateTime(false);
            } else if (response[0].InTime != null && response[0].OutTime != null) {
              this.AttendanceDetail.InTime = null;
              this.AttendanceDetail.OutTime = null;
              this.GetDateTime(false);
            } else {
              this.AttendanceDetail.InTime = null;
              this.AttendanceDetail.OutTime = null;
              this.isShowAttendaceBtn = true;
            }
          }
        } else {
          this.isShowAttendaceBtn = true;
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  GetDateTime(IsAction: boolean) {
    this.isDisabled = true;
    this.isShowAttendaceBtn = false;
    if (!this.AttendanceDetail.IsAttendaceClose || !IsAction) {
      this.utility.GetDateTime().subscribe({
        next: (response) => {
          if (IsAction && !this.AttendanceDetail.IsCheckIn) {
            this.AttendanceDetail.AttendanceDate = (moment(response.Current_Date).year() + '-' + (moment(response.Current_Date).month() + 1) + '-' + moment(response.Current_Date).date()).toString();
          } else {
            this.AttendanceDetail.AttendanceDate = (moment(this.AttendanceDetail.InTime).year() + '-' + (moment(this.AttendanceDetail.InTime).month() + 1) + '-' + moment(this.AttendanceDetail.InTime).date()).toString();
          }
          this.CurrentTime = moment(response.Current_Date);
          if (!this.AttendanceDetail.IsCheckIn && IsAction) {
            this.CheckIn();
          } else if (this.AttendanceDetail.IsCheckIn && IsAction) {
            this.CheckOut();
          } else if (this.AttendanceDetail.IsCheckIn && !IsAction) {
            this.CheckInStart(this.AttendanceDetail.InTime, true);
          } else {
            this.isShowAttendaceBtn = true;
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } else {
      this.toast.show({ message: 'Attendace not allowed for today.', type: toastTypeEnum.danger });
    }
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    return this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.ToDayDate = this.dateFromat.parse(response.Table[0].RegistrationDate);
        }
        this.LoadBirthdayDetails();

        this.GetCalendar(this.dateFromat.fullmonth[this.ToDayDate.month - 1], this.ToDayDate.year);
        this.ESS_GetESSAttendanceSummaryWeb(this.dateFromat.fullmonth[this.ToDayDate.month - 1], this.ToDayDate.year);
        this.isDisabled = false;
      },
      complete: () => {
        this.GetDailyAttendanceInOut();
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  getIPAddress() {
    this.isDisabled = true;
    return this.utility.getIPAddress().subscribe({
      next: (response) => {
        this.AttendanceDetail.IP = response.ip;
        this.isDisabled = false;
      },
      complete: () => {
        this.AttendanceInOutSave();
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }


  private setGreeting(): void {
    const currentHour = new Date().getHours();

    if (currentHour >= 5 && currentHour < 12) {
      this.greeting = 'Good morning!';
    } else if (currentHour >= 12 && currentHour < 18) {
      this.greeting = 'Good afternoon!';
    } else {
      this.greeting = 'Good evening!';
    }
  }

  GetPaySlip() {
    this.payslip.GetPayslip({ EmpMasterId: this.user.UserId }).subscribe({
      next: (response) => {
        try {
          if (response.Table != undefined) {
            this.PaySlipData = response.Table;
          } else {
            this.PaySlipData = []
          }
        } catch (e) {
          this.PaySlipData = []
        }
      },
      complete: () => {
        return true
      },
      error: (err) => {
        return false;
      }
    })
  }

  GeneratePaySlip(MonthName: string, YearName: string) {
    this.isDisabled = true;
    this.payslip.GeneratePayslip({ EmpMasterId: this.user.UserId, Month: MonthName, Year: YearName }).subscribe({
      next: (response) => {
        if (this.common.ToLowerCase(response.FileName) != "no file found" && this.common.ToLowerCase(response.FileName) != "") {
          window.open(this.common.CompanyParameterValue.HTTPSDownloadLink.replace(this.common.CompanyParameterValue.HTTPSDownloadLink.split('/')[this.common.CompanyParameterValue.HTTPSDownloadLink.split('/').length - 2] + '/', "") + '/' + response.FileName);
        } else {
          this.toast.show({ message: "Payslip not found", type: toastTypeEnum.dark });
        }

        this.isDisabled = false;
      },
      complete: () => {
        return true
      },
      error: (err) => {
        this.isDisabled = false;
        return false;
      }
    })
  }

  getHolidaylistonID() {
    this.Holidays = [];
    this.holiday.GetHolidayDetailsOnID({ EmpmasterId: this.user.UserId }).subscribe({
      next: (response) => {
        try {
          if (response.Table != undefined) {
            this.Holidays = response.Table;
          } else {
            this.Holidays = []
          }
        } catch (e) {
          this.Holidays = []
        }
      },
      complete: () => {
        return true
      },
      error: (err) => {
        return false;
      }
    })
  }

  onNavigate(event: any) {
    this.GetCalendar(this.dateFromat.fullmonth[event.next.month - 1], event.next.year);
    this.ESS_GetESSAttendanceSummaryWeb(this.dateFromat.fullmonth[event.next.month - 1], event.next.year);
  }

  GetCalendar(Month: String, Year: String) {
    this.Calendar.GetAttendanceCalendar({ MonthName: Month, YearName: Year, EmpMasterId: this.user.UserId, }).subscribe({
      next: (response) => {
        this.calendarData = response;
        if (this.filter.AttendanceDate == null) {
          this.filter.AttendanceDate = this.dateFromat.parse(moment(Date()).add({ day: -1 }).format("DD MMM YYYY"));
        }

        if (this.calendarData.filter(e => this.dateFromat.format(this.dateFromat.parse(moment(e.AttendanceDate).format("DD MMM YYYY"))) == this.dateFromat.format(this.dateFromat.parse(moment(this.dateFromat.format(this.filter.AttendanceDate)).format("DD MMM YYYY")))).length > 0) {
          this.GetDailyAttendanceInOutDetail(this.calendarData.filter(e => this.dateFromat.format(this.dateFromat.parse(moment(e.AttendanceDate).format("DD MMM YYYY"))) == this.dateFromat.format(this.dateFromat.parse(moment(this.dateFromat.format(this.filter.AttendanceDate)).format("DD MMM YYYY"))))[0].DailyAttendanceInOutID);
        } else {
          this.GetDailyAttendanceInOutDetail(0);
        }
      },
      complete: () => { },
      error: (error) => { },
    });
  }

  ESS_GetESSAttendanceSummaryWeb(Month: String, Year: String) {
    this.calendarDataSummary = [];
    this.Calendar.ESS_GetESSAttendanceSummaryWeb({ MonthName: Month, YearName: Year, EmpMasterID: this.user.UserId, }).subscribe({
      next: (response) => {
        if (response.Table.length > 0) {
          this.calendarDataSummary = response.Table;
        }
      },
      complete: () => { },
      error: (error) => { },
    });
  }

  getDayStyle(date: NgbDate): any {
    // const currentDate = new Date(date.year, date.month - 1, date.day);
    // const matchingEvent = this.calendarData.find(event =>
    //   new Date(event.InTime).toDateString() === currentDate.toDateString()
    // );
    if (date.year === this.ToDayDate.year && date.month === this.ToDayDate.month && date.day === this.ToDayDate.day) {
      // return {
      //   'background-color': '#0078d4af',
      //   'color': 'white',
      //   'padding': '2px'
      // };
      return {};
    } else if (date.year === this.filter.AttendanceDate.year && date.month === this.filter.AttendanceDate.month && date.day === this.filter.AttendanceDate.day) {
      return {
        'background-color': '#0078D4',
        'color': 'white',
        'border-radius': '.25rem'
      };
    }
    else {
      return {};
    }
  }

  // getDayDotStyle(date: NgbDate): any {
  //   const currentDate = new Date(date.year, date.month - 1, date.day);
  //   const matchingEvent = this.calendarData.find(event => new Date(event.InTime).toDateString() === currentDate.toDateString());

  //   if (matchingEvent) {
  //     if (date.year === this.ToDayDate.year && date.month === this.ToDayDate.month && date.day === this.ToDayDate.day
  //     ) {
  //       return {
  //         'background-color': '#0078d4af',
  //         'color': 'white',
  //         'padding': '2px'
  //       };
  //     } else if (date.year === this.filter.AttendanceDate.year && date.month === this.filter.AttendanceDate.month && date.day === this.filter.AttendanceDate.day) {
  //       return {
  //         'background-color': '#0078D4',
  //         'color': 'white',
  //         'padding': '2px'
  //       };
  //     } else {
  //       return {
  //         'background-color': matchingEvent.Color,
  //         'margin': '1px',
  //         'padding': '2px'
  //       };
  //     }
  //   } else {
  //     return {};
  //   }
  // }

  getDayDotStyle(date: NgbDate): any {
    const currentDate = new Date(date.year, date.month - 1, date.day);
    const matchingEvent = this.calendarData.find(event =>
      new Date(event.AttendanceDate).toDateString() === currentDate.toDateString()
    );

    if (matchingEvent) {
      const baseColor = matchingEvent.Color;
      const backgroundColor = baseColor;
      // this.Colour1 = baseColor;

      return {
        'background-color': backgroundColor,
        // 'left': this.Colour2 == '' ? '50%' : '30%'
      };
    } else {
      return {};
    }
  }

  getDayDotStyle2(date: NgbDate): any {
    const currentDate = new Date(date.year, date.month - 1, date.day);
    const matchingEvent = this.calendarData.find(event =>
      new Date(event.AttendanceDate).toDateString() === currentDate.toDateString()
    );

    if (matchingEvent) {
      const baseColor = matchingEvent.ColorNew;
      const backgroundColor = baseColor;
      this.Colour2 = baseColor

      return {
        'background-color': backgroundColor,
      };
    } else {
      return {};
    }
  }

  CalenderDateSelect(event: any) {
    if (this.calendarData.filter(e => this.dateFromat.format(this.dateFromat.parse(moment(e.AttendanceDate).format("DD MMM YYYY"))) == this.dateFromat.format(event)).length > 0) {
      this.GetDailyAttendanceInOutDetail(this.calendarData.filter(e => this.dateFromat.format(this.dateFromat.parse(moment(e.AttendanceDate).format("DD MMM YYYY"))) == this.dateFromat.format(event))[0].DailyAttendanceInOutID);
    } else {
      this.CalendarDetailsData.id = 0;
      this.CalendarDetailsData.Photo = this.user.EPhoto;
      this.CalendarDetailsData.EmployeeName = this.user.UserName;
      this.CalendarDetailsData.EmpCode = null;
      this.CalendarDetailsData.DesignationName = this.user.EDesignation;
      this.CalendarDetailsData.AttendanceDate = this.filter.AttendanceDate;
      this.CalendarDetailsData.InTime = null;
      this.CalendarDetailsData.OutTime = null;
      this.CalendarDetailsData.ShiftTitle = null;
      this.CalendarDetailsData.Remark = null;
      this.CalendarDetailsData.DailyAttendancePhoto = null;
      this.CalendarDetailsData.DailyAttendancePhotoOut = null;
      this.CalendarDetailsData.InReason = null;
      this.CalendarDetailsData.OutReason = null;
      this.CalendarDetailsData.AttendanceDescription = null;
    }
  }

  GetDailyAttendanceInOutDetail(id: number) {
    if (id > 0) {
      this.isDisabled = true;
      this.attendance.GetDailyAttendanceInOut({ DailyAttendanceInOutID: id, SelectType: 2, EmpMasterId: this.user.UserId, FromDate: null, ToDate: null, ApprovalStatus: 'ALL' }).subscribe({
        next: (response) => {
          if (response.toString() != '') {
            this.CalendarDetailsData.id = id;
            this.CalendarDetailsData.Photo = response[0].Photo;
            this.CalendarDetailsData.EmployeeName = response[0].EmployeeName;
            this.CalendarDetailsData.EmpCode = response[0].EmpCode;
            this.CalendarDetailsData.DesignationName = response[0].DesignationName;
            this.CalendarDetailsData.AttendanceDate = (response[0].AttendanceDate != null && response[0].AttendanceDate != "") ? this.dateFromat.parse(response[0].AttendanceDate.split("-")[2] + " " + this.dateFromat.month[parseInt(response[0].AttendanceDate.split("-")[1]) - 1] + " " + response[0].AttendanceDate.split("-")[0]) : '';
            this.CalendarDetailsData.InTime = response[0].InTime;
            this.CalendarDetailsData.OutTime = response[0].OutTime;
            this.CalendarDetailsData.ShiftTitle = response[0].ShiftTitle;
            this.CalendarDetailsData.Remark = response[0].Remark;
            this.CalendarDetailsData.DailyAttendancePhoto = this.calendarData.filter(e => e.DailyAttendanceInOutID == id)[0]["DailyAttendancePhoto"];
            this.CalendarDetailsData.DailyAttendancePhotoOut = this.calendarData.filter(e => e.DailyAttendanceInOutID == id)[0]["DailyAttendancePhotoOut"];
            this.CalendarDetailsData.InReason = (this.calendarData.filter(e => e.DailyAttendanceInOutID == id)[0]["InReason"] != null && this.calendarData.filter(e => e.DailyAttendanceInOutID == id)[0]["InReason"] != "") ? this.calendarData.filter(e => e.DailyAttendanceInOutID == id)[0]["InReason"].split("-")[1] : "";
            this.CalendarDetailsData.OutReason = (this.calendarData.filter(e => e.DailyAttendanceInOutID == id)[0]["OutReason"] != null && this.calendarData.filter(e => e.DailyAttendanceInOutID == id)[0]["OutReason"] != "") ? this.calendarData.filter(e => e.DailyAttendanceInOutID == id)[0]["OutReason"].split("-")[1] : "";
            this.CalendarDetailsData.AttendanceDescription = (this.calendarData.filter(e => e.DailyAttendanceInOutID == id)[0]["AttendanceDescription"] != null && this.calendarData.filter(e => e.DailyAttendanceInOutID == id)[0]["AttendanceDescription"] != "") ? this.calendarData.filter(e => e.DailyAttendanceInOutID == id)[0]["AttendanceDescription"].split(':')[1] : '';
          } else {
            this.CalendarDetailsData.id = 0;
            this.CalendarDetailsData.Photo = this.user.EPhoto;
            this.CalendarDetailsData.EmployeeName = this.user.UserName;
            this.CalendarDetailsData.EmpCode = null;
            this.CalendarDetailsData.DesignationName = this.user.EDesignation;
            this.CalendarDetailsData.AttendanceDate = this.filter.AttendanceDate;
            this.CalendarDetailsData.InTime = null;
            this.CalendarDetailsData.OutTime = null;
            this.CalendarDetailsData.ShiftTitle = null;
            this.CalendarDetailsData.Remark = null;
            this.CalendarDetailsData.DailyAttendancePhoto = null;
            this.CalendarDetailsData.DailyAttendancePhotoOut = null;
            this.CalendarDetailsData.InReason = null;
            this.CalendarDetailsData.OutReason = null;
            this.CalendarDetailsData.AttendanceDescription = null;
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } else {
      this.CalendarDetailsData.id = 0;
      this.CalendarDetailsData.Photo = this.user.EPhoto;
      this.CalendarDetailsData.EmployeeName = this.user.UserName;
      this.CalendarDetailsData.EmpCode = null;
      this.CalendarDetailsData.DesignationName = this.user.EDesignation;
      this.CalendarDetailsData.AttendanceDate = this.filter.AttendanceDate;
      this.CalendarDetailsData.InTime = null;
      this.CalendarDetailsData.OutTime = null;
      this.CalendarDetailsData.ShiftTitle = null;
      this.CalendarDetailsData.Remark = null;
      this.CalendarDetailsData.DailyAttendancePhoto = null;
      this.CalendarDetailsData.DailyAttendancePhotoOut = null;
      this.CalendarDetailsData.InReason = null;
      this.CalendarDetailsData.OutReason = null;
      this.CalendarDetailsData.AttendanceDescription = null;
    }
  }

  LoadEmployeeLeaveCombo() {
    this.isDisabled = true;
    this.leave.LoadEmployeeLeaveCombo({ EmpMasterID: this.user.UserId, ComboType: 'LeaveMaster' }).subscribe({
      next: (response) => {
        try {
          if (response.ComboLoad != undefined) {
            this.LeaveTypes = response.ComboLoad;
          } else {
            this.LeaveTypes = []
          }
        } catch (e) {
          this.LeaveTypes = []
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  LeaveSum() {
    const LeaveCount = this.LeaveTypes.map((e: any) => e.LeaveOB).reduce((acc: any, cur: any) => acc + cur, 0)
    return LeaveCount + this.CompOffCount; //this.LeaveTypes.map((e: any) => e.LeaveOB).reduce((acc: any, cur: any) => acc + cur, 0)
  }

  LoadBirthdayDetails() {
    this.post.BirthDayDetails({ 'EmpMasterId': this.user.UserId }).subscribe({
      next: (response) => {
        try {
          if (response.Table != undefined) {
            this.TodayBirthdayDetails = response.Table;
          } else {
            this.TodayBirthdayDetails = []
          }
        } catch (e) {
          this.TodayBirthdayDetails = []
        }
      },
      complete() { },
      error(err) { },
    });
  }

  GetFeedLoad() {
    this.post.PostLoad({ SelectType: 1, ESS_PostMasterID: 0 }).subscribe({
      next: (response) => {
        try {
          if (response.Table != undefined) {
            this.FeedDetails = response.Table;
          } else {
            this.FeedDetails = [];
          }
        } catch (e) {
          this.FeedDetails = [];
        }
      },
      complete() { },
      error(err) { },
    });
  }

  InsertCommentPost(PostMasterID: number) {
    this.post.CommentInsert({ 'ESS_PostMasterID': PostMasterID, 'Comment': this.Comment }).subscribe({
      next: (Response) => {
        if (Response.Error_Code == '01') {
          this.toast.show({ message: Response.Error_Message, type: toastTypeEnum.success });
          this.LoadCommentPost(PostMasterID);
        }
        else {
          this.toast.show({ message: Response.Error_Message, type: toastTypeEnum.danger });
        }
      },
      complete() { },
      error(err) { },
    })
  }

  LoadCommentPost(PostId: number) {
    this.post.CommentLoad({ 'SelectType': 1, 'ESS_PostMasterID': PostId }).subscribe({
      next: (Response) => {
        console.log(Response);
        this.Comments = Response.Table;
      },
      complete() { },
      error(err) { },
    })
  }

  toggleCommentSection(index: number, postID: number) {
    this.LoadCommentPost(postID)
    if (this.commentSectionVisibleIndex === index) {
      this.commentSectionVisibleIndex = null;
    } else {
      this.commentSectionVisibleIndex = index;
    }
  }

  LikePost(PostMasterID: number) {
    this.post.LikeInsert({ 'ESS_PostMasterID': PostMasterID }).subscribe({
      next: (Response) => {
        if (Response.Error_Code == '01') {
          this.toast.show({ message: Response.Error_Message, type: toastTypeEnum.success });
          this.GetFeedLoad();
        }
        else {
          this.toast.show({ message: Response.Error_Message, type: toastTypeEnum.danger });
        }
      },
      complete() { },
      error(err) { },
    })
  }

  ESS_EmployeeCompOffConsumeLoad() {
    this.isDisabled = true;
    this.CompOff.ESS_EmployeeCompOffConsumeLoad({ 'SelectType': 1, 'EmpMasterID': this.AttendanceDetail.EmpMasterId, 'FromDate': null, 'ToDate': null, }).subscribe({
      next: (response) => {
        if (response.Table.length > 0) {
          this.CompOffTable = response.Table;
          this.CompOffCount = response.Table[0].TotalBalance;
          console.log('count', this.CompOffTable);
        } else {
          this.CompOffCount = 0;
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_GetLoginDetails(isAuto: Boolean) {
    this.isDisabled = true;
    this.login.ESS_GetLoginDetails({ SelectType: 'AuthInfo', LoginName: this.user.EmpCode, TokenUserName: this.user.TokenUserName, TokenPassword: this.user.TokenPassword, TokenAppName: this.user.TokenAppName, Token: this.user.Token, SessionID: this.user.SessionID, OpType: this.user.OpType, UserType: this.user.UserType }, this.user.ApiUrl).subscribe({
      next: (response) => {
        this.user.IsPopFirstTimeMpin = false;
        this.session.Start(this.user);
        if (response && response.Table.length > 0) {
          if (response.Table[0].IsMPINEnabled && ((isAuto && response.Table[0].IsMPINSet == 0) || !isAuto)) {
            const modalRef = this.modalService.open(MPINDialogComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.result.then((result: any) => { }).catch(() => { });
          }
        } else {
          //this.session.End();
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  calculateTotalDuration(startTime: any, endTime: any): string {
    if (startTime !== null && endTime !== null) {
      const [startHours, startMinutes, startSeconds] = startTime.split(':').map(Number);
      const [endHours, endMinutes, endSeconds] = endTime.split(':').map(Number);

      const now = new Date();

      const start = new Date(now);
      start.setHours(startHours, startMinutes, startSeconds, 0);

      const end = new Date(now);
      end.setHours(endHours, endMinutes, endSeconds, 0);

      // Handle next day case
      if (end < start) {
        end.setDate(end.getDate() + 1);
      }

      const diffMs = end.getTime() - start.getTime();
      const totalMinutes = Math.floor(diffMs / (1000 * 60));
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;

      // Pad with zero if needed (e.g., "02:05")
      const formatted = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
      return formatted;
    }
    return '';
  }

}
